import { apiEndPoints, apiMethods } from '../../../../../utils/apiConstants'
import customAxios from '../../../../../utils/customAxios'

export const getDashboardDataThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getUserDashboardDetails)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const userDashboardDataThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.userDashboardData)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}
